import { ComponentRef, Injectable, ViewContainerRef } from '@angular/core';

import { UmssToastComponent } from '../components/toast/toast.component';
import {
  DEFAULT_TOAST_CONFIG,
  ToastAlertConfig,
  ToastAlertConfigInput
} from '../components/toast/toast.model';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private vcr?: ViewContainerRef;

  private componentRef?: ComponentRef<UmssToastComponent>;

  registerContainer(vcr: ViewContainerRef) {
    this.vcr = vcr;
  }

  openToast(config: ToastAlertConfigInput): void {
    if (!this.vcr) {
      throw new Error(
        'ToastService: No ViewContainerRef registered. Call registerContainer() in your root component.'
      );
    }

    if (!this.componentRef) {
      this.componentRef = this.vcr.createComponent(UmssToastComponent);

      this.componentRef.instance.allClose.subscribe(() => {
        this.componentRef?.destroy();
        this.componentRef = undefined;
        this.vcr?.clear();
      });
    }

    this.componentRef.instance.addAlert(this.createToastConfig(config));
  }

  private createToastConfig(config: ToastAlertConfigInput): ToastAlertConfig {
    return {
      ...DEFAULT_TOAST_CONFIG,
      ...config,
      duration:
        config.duration ||
        this.computeBestDuration(config.title + ' ' + config.description || '')
    };
  }

  private computeBestDuration(content: string): number {
    const wordsPerSecond = 2;
    const words = content.split(/\s+/).length;
    const seconds = Math.ceil(words / wordsPerSecond);
    return Math.max(DEFAULT_TOAST_CONFIG.duration, seconds * 1000);
  }
}
